export default __webpack_public_path__ + "static/media/wellcare_by_allwell.af789f99.jpg";